
export const arrayMax = (inputArray: number[]): number =>
  Math.max(...inputArray);

export const arrayMin = (inputArray: number[]): number =>
  Math.min(...inputArray);
